import React from "react";
import BuyerDetails from "./BuyerDetails";

const MyAccountBuyerDetails = () => {
  return (
    <div className="tab-pane fade active show">
      <BuyerDetails />
    </div>
  );
};

export default MyAccountBuyerDetails;

